module.exports = __webpack_public_path__ + "myanmar/kylin/static1/img/home.97f4c40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home.png
// module id = yvNz
// module chunks = 1